import styled from 'styled-components';
import theme from 'theme/theme';

const ModalHeader = styled.header`
  display: flex;
  align-items: center;
  margin: -25px -25px 25px -25px;
  padding: 10px 10px 10px 50px;
  background: ${theme.colors.primary};
  
  @media (min-width: ${theme.breakpoints.tablet}) {
    padding-left: 80px;
  }
  @media (min-width: ${theme.breakpoints.desktopLarge}) {
    margin: 0;
    padding: 0 0 30px 0;
    background: transparent;
  }
`;

export default ModalHeader;

export const FullScreenModalHeader = styled.div`
  min-height: 48px;
  display: flex;
  align-items: center;
  padding: 5px 10px 5px 80px;
  background: ${theme.colors.primary};
  color: ${theme.colors.white};
  
  @media (min-width: ${theme.breakpoints.desktopLarge}) {
    padding: 5px 50px 5px 25px;
  }
`;
